import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import EMAIL_REGEX from '../../../validators/regex/email.regex';
import {Router} from '@angular/router';
import {PasswordVerificationService} from '../../../services/password-verification.service';
import {NotificationService} from '../../../services/notification.service';
import {Err} from '../../../err';
import {UserService} from '../../../services/user.service';

@Component({
  templateUrl: './edit-email.component.html'
})
export class EditEmailComponent implements OnInit {

  private passwordVerified: boolean;

  emailForm: FormGroup;
  emailSubmitted = false;
  emailValid: boolean;
  emailError;

  code;
  codeError;

  constructor(private passwordVerificationService: PasswordVerificationService,
              private service: UserService,
              private notificationService: NotificationService,
              private router: Router,
              private builder: FormBuilder) {
  }

  ngOnInit(): void {
    this.emailForm = this.builder.group({
      'username': ['', [Validators.required, Validators.pattern(EMAIL_REGEX), Validators.maxLength(255)]],
    });
    this.passwordVerificationService.checkPassword()
      .then(() => this.passwordVerified = true);
  }

  submitEmail(value) {
    this.emailSubmitted = true;
    if (this.emailForm.invalid) return;
    this.service.checkEmailAdress({email: value.username}).subscribe(
      () => {
        this.emailValid = true;
        this.emailError = null;
      },
      error => {
        this.emailValid = false;
        this.emailError = Err[error.error.message];
      });
  }

  codeChanged($event: any) {
    if ($event.trim().length === 15) {
      this.service.checkEmailChangeConfirmationCode({code: $event.trim()}).subscribe(() => {
        this.service.logout();
        this.router.navigate(['/e-mailadres-aanpassen/gelukt']);
      }, error => {
        this.codeError = Err[error.error.message];
      });
    }
  }

  resend() {
    this.service.resendEmailConfirmationMail()
      .subscribe(() => this.notificationService.success('mail opnieuw verstuurd'));
  }
}
